import "../globals.css"

import { Outlet, createRootRoute } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'

import { AuthUIProvider } from "@daveyplate/better-auth-ui"
import type React from "react"
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { ThemeProvider, useTheme } from "../contexts/theme-provider"
import { Toaster } from "../components/ui/sonner"
import { authClient } from "../lib/auth-client"
import { ExtensionInstallPrompt } from "../components/extension-install-prompt"
import { toast } from "sonner"
import { queryClient } from "../lib/query-client"

// HMR configuration - accept CSS updates and dismiss toasts on reload
if (import.meta.hot) {
  // Accept CSS updates without full page reload
  import.meta.hot.accept('../globals.css', () => {
    // CSS is handled by Vite automatically, just prevent full reload
  })

  // Cleanup on module disposal
  import.meta.hot.dispose(() => {
    toast.dismiss()
  })
}

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponentInner() {
  const { theme } = useTheme()

  return (
    <>
      <Outlet />
      <Toaster theme={theme} />
      <ExtensionInstallPrompt />
      {/* <TanStackRouterDevtools position="bottom-right" /> */}
    </>
  )
}

function RootComponent() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="app-theme">
      <QueryClientProvider client={queryClient}>
        <AuthUIProvider authClient={authClient}>
          <RootComponentInner />
        </AuthUIProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
